export default [
  {
    srno: "20213",
    // title: "Sumit Jaiswal ",
    subtitle: "Sumit  ",
    description: "Jaiswal",
    imgurl: "1234	",
    tags: "Student	"
  },
  
];
